var dynamicRequire = require('../dynamicRequire');
var React = dynamicRequire('react');
var AccordionTab = dynamicRequire('AccordionTab.jsx');
var Mssg = dynamicRequire('Mssg.jsx');
var SVGIcon = dynamicRequire('SVGIcon.jsx');

var Parts = require('./Options/Parts.jsx');
var Wheels = require('./Options/Wheels.jsx');
var Foam = require('./Options/Foam.jsx');
var ConfigurationOption = require('./Options/Option.jsx');
var Accessories = require('./Options/Accessories.jsx');

class Options extends React.Component {
    render() {
        if(this.hasNoOptions()) {
            return <span />;
        }

        return <div className="lr-casefactory-choices-accordion lr-sidebar-accordion choices-accordion sidebar-accordion">
            {this.getBaseChoices()}

            <AccordionTab name="options" group='caseconfigurator'>
                <strong className="headline"><Mssg __key="nc_casefactory.options" /><SVGIcon identifier={'plus'}/><SVGIcon identifier={'minus'}/></strong>
                <div className="lr-casefactory-choices-options options">
                    {!this.props.case.isKeyboardcase && this.hasWheels() ?
                        <Wheels isDoubleDoorRack={this.props.case.isDoubleDoorRack} wheelId={this.props.case.WHEEL}
                                wheels={this.getWheels()} key='wheels'/> : ''}
                    {this.hasFoam() ? <Foam foamId={this.props.case.FOAM} foams={this.getFoams()} key='foam'/> : ''}
                    {this.props.options.map((option) => {
                        return <ConfigurationOption case={this.props.case} key={option} option={option}
                                                    conflicts={this.props.conflicts} infos={this.props.infos}
                                                    label={this.getOptionLabel(option)}/>
                    })}
                </div>
            </AccordionTab>

            {this.hasAccessories() ? <Accessories {...this.props} /> : ''}
        </div>
    }

    hasNoOptions() {
        return this.props.case.isKeyboardcase && !this.props.options.length && !this.hasFoam();
    }

    hasAccessories() {
        return this.props.possibleParts.reduce((prev, cur) => {
            return prev || cur.category.indexOf('ACCESSORY')===0;
        }, false)
    }

    hasFoam() {
        return this.getFoams().length
    }

    getBaseChoices() {
        if(this.props.case.isKeyboardcase){
            return '';
        }else {
            return <div>
                {this.hasShutters() ? <Parts basePath={this.props.basePath} parts={this.getShutters()} key='fastener' event='fastener' title='nc_casefactory.shutter' id={this.props.case.FASTENER} /> : ''}
                {this.hasGrips() ? <Parts basePath={this.props.basePath} parts={this.getGrips()} key='handle' event='handle' title='nc_casefactory.grip' id={this.props.case.HANDLE} /> : ''}
                {this.hasCorners() ? <Parts basePath={this.props.basePath} parts={this.getCorners()} key='corners' event='corners' title='nc_casefactory.corners' id={this.props.case.CORNER} /> : ''}
            </div>
        }
    }

    hasCorners() {
        return this.getCorners().length
    }

    hasGrips() {
        return this.getGrips().length
    }

    hasShutters() {
        return this.getShutters().length
    }

    hasWheels() {
        return this.getWheels().length;
    }

    isDoubleDoorRack() {
        return this.props.case.isDoubleDoorRack;
    }

    getShutters() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'FASTENER';
        });
    }

    getGrips() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'HANDLE';
        });
    }

    getFoams() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'FOAM';
        });
    }

    getCorners() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'CORNER';
        });
    }

    getWheels() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'WHEEL' || part.category == 'ROLL_BOARD' || part.category == 'STAND';
        });
    }

    getOptionLabel(option) {
        var mapping = {
            STACKABLE: 'nc_casefactory.option.stackable',
            PLAYABLE_IN_CASE: 'nc_casefactory.option.in.case.playable',
            ACCESSORIES_COMPARTMENT: 'nc_casefactory.option.accessory.box',
            TROLLEY_FUNCTION: 'nc_casefactory.option.trolley.function',
            REMOVABLE_CAP: 'nc_casefactory.option.cap.removable',
            LEATHER_HANDLE: 'nc_casefactory.option.with.leathergrip',
            ADDITIONAL_BACK_RACKRAIL: 'nc_casefactory.option.back.racks',
        }
        return mapping[option];
    }
}

Options.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};

module.exports = Options;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options.jsx